<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <h4 class="modalTitle">Choose Section Type</h4>
        <div class="close" v-on:click="close(false)"></div>
        <div class="selectorCnt">
          <div class="selectorItem" v-on:click="close(true, 'Image Header')">
            <div class="icon headerImg">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
            </div>
            <h4>Image Header</h4>
            <p>Article text for story.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Slider')">
            <div class="icon slider">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i2 i2a"></div>
            </div>
            <h4>Slider</h4>
            <p>Video content single page.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Gallery')">
            <div class="icon gallery">
              <div class="iconItem"></div>
              <div class="iconItem"></div>
              <div class="iconItem"></div>
              <div class="iconItem"></div>
              <div class="iconItem"></div>
              <div class="iconItem"></div>
            </div>
            <h4>Gallery</h4>
            <p>Single or multiple image displayed as gallery.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Block Articles')">
            <div class="icon article">
              <div class="iconItem i1"></div>
              <div class="iconItem i1"></div>
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i2"></div>
            </div>
            <h4>Block Articles</h4>
            <p>PDF Document displayed with PDF Viewer.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Left Image')">
            <div class="icon imleft">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
            </div>
            <h4>Left Image</h4>
            <p>Add new an event in calendar.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Right Image')">
            <div class="icon imright">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
            </div>
            <h4>Right Image</h4>
            <p>User profile view.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Two Image')">
            <div class="icon twoimg">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
            </div>
            <h4>Two Image</h4>
            <p>User profile view.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Image')">
            <div class="icon topimg">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
            </div>
            <h4>Image</h4>
            <p>User profile view.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Video')">
            <div class="icon topimg video">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
            </div>
            <h4>Video</h4>
            <p>User profile view.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Icon Slider')">
            <div class="icon iconSlider">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
            </div>
            <h4>Icon Slider</h4>
            <p>User profile view.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Subscription')">
            <div class="icon newsletter">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
            </div>
            <h4>Subscription</h4>
            <p>Content that link to another website.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Text Block')">
            <div class="icon text">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
            </div>
            <h4>Text Block</h4>
            <p>Content that link to another website.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Form')">
            <div class="icon form">
              <div class="iconItem i1"></div>
              <div class="iconItem i2"></div>
              <div class="iconItem i3"></div>
              <div class="iconItem i4"></div>
            </div>
            <h4>Form</h4>
            <p>Content that link to another website.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Map')">
            <div class="icon map"></div>
            <h4>Map</h4>
            <p>Content that link to another website.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Timeline')">
            <div class="icon timeline"></div>
            <h4>Timeline</h4>
            <p>Time series information.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'Custom Block')">
            <div class="icon custom"></div>
            <h4>Custom Block</h4>
            <p>Content that link to another website.</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
    };
  },
  methods: {
    open(next) {
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 60px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 760px;
      box-sizing: border-box;
      .close{
        position: absolute;
        right: 10px; top: 10px;
        width: 34px; height: 34px;
        background-color: #eee;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        opacity: .36;
        transition: all .3s ease;
        &:hover{
          opacity: .65;
        }
      }
      .modalTitle{
        padding: 30px 74px 10px;
        font-size: 24px;
        margin: -30px -60px 20px;
        border-bottom: #eee 1px solid;
        font-weight: 600;
      }
      .selectorCnt{
        display: flex;
        flex-wrap: wrap;
        .selectorItem{
          padding: 14px;
          // padding-left: 70px;
          border: #fff 1px solid;
          border-radius: 10px;
          transition: all .2s ease;
          position: relative;
          box-sizing: border-box;
          width: 25%;
          text-align: center;
          margin-bottom: 10px;
          .icon{
            height: 60px;
            margin: 0 0 10px;
            position: relative;
            .iconItem{
              // background-color: #0067ff;
              background-color: #d5d5d5;
              transition: background-color .3s ease;
            }
            &.headerImg{
              .iconItem{
                &.i1{
                  height: 42px;
                  border-radius: 5px;
                  margin: 0 0 4px;
                }
                &.i2{
                  height: 4px;
                  border-radius: 50px;
                  width: 30%;
                }
              }
            }
            &.slider{
              .iconItem{
                &.i1{
                  height: 60px;
                  border-radius: 5px;
                }
                &.i2{
                  position: absolute;
                  left: 6px; top: 50%;
                  width: 10px; height: 10px;
                  background-color: #fff;
                  margin-top: -5px;
                  border-radius: 50%;
                  &.i2a{
                    left: auto; right: 6px;
                  }
                }
              }
            }
            &.gallery{
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              align-items: center;
              .iconItem{
                width: calc(33.33333% - 6px);
                height: 25px;
                margin: 0 3px;
                border-radius: 3px;
              }
            }
            &.article{
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              align-items: center;
              .iconItem{
                width: calc(33.33333% - 6px);
                height: 25px;
                margin: 0 3px;
                border-radius: 3px;
                &.i2{
                  background-color: transparent;
                  position: relative;
                  height: 22px;
                  &:before,
                  &:after{
                    content: "";
                    position: absolute;
                    height: 3px;
                    left: 0; top: 0;
                    width: 76%;
                    background-color: #d5d5d5;
                    border-radius: 50px;
                  }
                  &:after{
                    top: 6px;
                    width: 40%;
                  }
                }
              }
            }
            &.imleft,
            &.imright{
              .iconItem{
                position: absolute;
                &.i1{
                  left: 5px; top: 5px;
                  width: 50px; height: 50px;
                  border-radius: 5px;
                }
                &.i2{
                  top: 50%; left: 64px;
                  height: 4px; width: 30px;
                  border-radius: 50px;
                  margin-top: -8px;
                }
                &.i3{
                  top: 50%; left: 64px;
                  height: 4px; width: 20px;
                  border-radius: 50px;
                }
              }
            }
            &.imright{
              .iconItem{
                &.i1{
                  left: auto; right: 5px;
                }
                &.i2, &.i3{
                  left: auto; right: 64px;
                }
              }
            }
            &.twoimg{
              .iconItem{
                position: absolute;
                &.i1{
                  left: 8px; top: 7px;
                  width: 46px; height: 46px;
                  border-radius: 5px;
                  &:before{
                    content: "";
                    position: absolute;
                    right: -12px; height: 46px;
                    width: 1px;
                    background-color: #d5d5d5;
                  }
                }
                &.i2{
                  top: 7px; right: 8px;
                  height: 46px; width: 46px;
                  border-radius: 5px;
                }
              }
            }
            &.topimg{
              .iconItem{
                position: absolute;
                &.i1{
                  left: 50%; top: 10px;
                  margin-left: -20px;
                  width: 40px; height: 40px;
                  border-radius: 5px;
                }
                &.i2{
                  top: 2px; left: 50%;
                  height: 3px; width: 30px;
                  margin-left: -15px;
                  border-radius: 5px;
                }
                &.i3{
                  bottom: 2px; left: 50%;
                  height: 3px; width: 30px;
                  margin-left: -15px;
                  border-radius: 5px;
                }
              }
              &.video{
                .iconItem{
                  &.i1{
                    width: 80px;
                    margin-left: -40px;
                    &:before{
                      content: "";
                      position: absolute;
                      width: 20px; height: 20px;
                      left: 50%; top: 50%;
                      margin: -10px 0 0 -10px;
                      background-image: url(../assets/play.png);
                      background-size: 14px auto;
                      background-position: center;
                      background-repeat: no-repeat;
                    }
                  }
                }
              }
            }
            &.iconSlider{
              display: flex;
              align-items: center;
              .iconItem{
                width: calc(33.33333% - 10px);
                height: 22px;
                margin: 0 5px;
                border-radius: 3px;
                position: relative;
                &:before{
                  content: "";
                  position: absolute;
                  left: 50%; top: 50%;
                  width: 8px; height: 8px;
                  border-radius: 2px;
                  background-color: rgba(0, 0, 0, .16);
                  margin: -4px 0 0 -4px;
                }
                &.i2{
                  transform: scale(1.4);
                }
              }
            }
            &.newsletter{
              position: relative;
              .iconItem{
                position: absolute;
                &.i1{
                  left: 0; right: 0;
                  top: 10px; height: 40px;
                  border-radius: 5px;
                }
                &.i2{
                  height: 8px; top: 50%;
                  left: 24px; right: 50px;
                  background-color: #fff;
                  border-radius: 50px;
                  margin-top: -4px;
                }
                &.i3{
                  height: 8px; top: 50%;
                  right: 24px;
                  background-color: rgba(0, 0, 0, .16);
                  border-radius: 50px;
                  margin-top: -4px;
                  width: 20px;
                }
              }
            }
            &.text{
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              .iconItem{
                height: 4px;
                margin: 3px 0;
                border-radius: 50px;
                width: 30%;
                &.i2{
                  height: 5px;
                  width: 75%;
                }
                &.i3{
                  width: 46%;
                }
              }
            }
            &.form{
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              .iconItem{
                height: 4px;
                margin: 1px 0;
                border-radius: 50px;
                width: 34%;
                background-color: transparent;
                border: #ccc 1px solid;
                &.i4{
                  background-color: #d5d5d5;
                  border-color: #d5d5d5;
                  margin-top: 6px;
                }
              }
            }
            &.custom{
              background-image: url(../assets/embed-code-wide.png);
              background-size: 46px auto;
              background-position: center;
              background-repeat: no-repeat;
              opacity: .36;
            }
            &.map{
              background-image: url(../assets/map-icon.png);
              background-size: auto 46px;
              background-position: center;
              background-repeat: no-repeat;
              opacity: .4;
            }
            &.timeline{
              background-image: url(../assets/timeline.png);
              background-size: auto 46px;
              background-position: center;
              background-repeat: no-repeat;
              opacity: .4;
            }
          }
          h4{
            margin: 0;
            font-size: 14px;
            font-weight: 600;
          }
          p{
            color: #767676;
            font-size: 11px;
            margin: 0;
            display: none;
          }
          &:hover{
            cursor: pointer;
            background-color: #f5f5f5;
            .icon{
              .iconItem{
                background-color: #0067ff;
              }
              &.form{
                .iconItem{
                  background-color: transparent;
                  border-color: #0067ff;
                  &.i4{
                    background-color: #0067ff;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
